import { type UseQueryResult, useQuery } from 'react-query';

import {
  PsuAwardSharedService,
  RsuAwardSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto,
  type Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto,
  type Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto,
  MyHoldingsSharedService,
  MyHoldingsRsuAwardSharedService,
} from '../../services/wealthlane-award-services';

const useGetAwardDetailsById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string,
  awardType?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto
  | Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto
  | Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto
  | undefined,
  unknown
> => {
  const awardDetails = useQuery(
    ['awardDetails', id, awardType],
    async () => {
      if (id && awardType === 'RSU') {
        return await handleRequest(
          RsuAwardSharedService.getApiAwardApiAppRSUAwardRSUAwardDetailByRSuVestingDateIdForParticipant(
            id
          )
        );
      }
      if (id && awardType === 'RSA') {
        // An RSA purchase lot is keyed by its award, not by a vesting date.
        return await handleRequest(
          MyHoldingsRsuAwardSharedService.getApiAwardApiAppMyHoldingsRSUAwardOverview(id)
        );
      }
      if (id && awardType === 'PSU') {
        return await handleRequest(
          PsuAwardSharedService.getApiAwardApiAppPSUAwardPSUAwardDetailByPSuVestingDateIdForParticipant(
            id
          )
        );
      }
      if (id && (awardType === 'Options' || awardType === 'ISO' || awardType === 'NQSO')) {
        return await handleRequest(
          MyHoldingsSharedService.getApiAwardApiAppMyHoldingsOptionAwardOverview(id)
        );
      }
    },
    { enabled: !!id }
  );

  return awardDetails;
};

export default useGetAwardDetailsById;
